<template>
  <div class="white">
    <v-toolbar flat color="white">
      <v-toolbar-title>Documentação</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            v-if="showDownloadButton"
            dark
            small
            fab
            color="#696A6D"
            @click="downloadExcel()"
          >
            <v-icon>download</v-icon>
          </v-btn>
        </template>
        <span>Download excel</span>
      </v-tooltip>

      <DocumentationFormDlg
        ref="docsForm"
        :addButton="docsPermissions && docsPermissions.edit"
        :condominiumList="condominiumList"
        :dialog="frmDocumentationDialog"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :saveDocumentation="
          (data, callback) => saveDocumentation(data, callback)
        "
        :editFormData="formData"
      />

      <UploadFileDoc
        v-if="docsPermissions && docsPermissions.edit"
        :dialog="uploadDialog"
        :openForm="() => openDialogForm('upLoad')"
        :closeForm="() => closeDialogForm('upLoad')"
        :sendFile="(data) => sendFile(data)"
        :editFormData="formData"
        uploadType="Docs"
      />
    </v-toolbar>

    <SearchDocumentations
      ref="searchDocs"
      :searchDocumentations="(documentation) => getDocumentation(documentation)"
    />

    <v-layout
      row
      wrap
      white
      pl-3
      infoDocs
      v-if="lastSearch != null"
      v-show="!inactivesShow"
    >
      <v-flex no-wrap xs2 text-xs-left>
        <!-- <strong class="small">Vigentes</strong> -->
        <v-chip
          v-if="true"
          color="white"
          :class="['pl-0', statusSel.selVig ? 'vigente' : '']"
          @click="selChip('selVig')"
          label
          small
        >
          <v-icon color="#50ae55" class="pr-1 mr-2 negativeMargin"
            >check_circle</v-icon
          >
          Vigentes {{ allStatus["vingente"] }}
        </v-chip>
      </v-flex>
      <v-flex no-wrap xs2 text-xs-left>
        <!-- <strong class="small">Vigentes</strong> -->
        <v-chip
          v-if="true"
          color="white"
          label
          small
          :class="['pl-0', statusSel.aVencer ? 'aVencer' : '']"
          @click="selChip('aVencer')"
        >
          <v-icon color="#f98c25" class="pr-1 mr-2 negativeMargin"
            >warning</v-icon
          >
          A vencer {{ allStatus["a_vencer"] }}
        </v-chip>
      </v-flex>
      <v-flex no-wrap xs2 text-xs-left>
        <!-- <strong class="small">Vigentes</strong> -->
        <v-chip
          v-if="true"
          color="white"
          :class="['pl-0', statusSel.vencidos ? 'vencidos' : '']"
          @click="selChip('vencidos')"
          label
          small
        >
          <v-icon color="#f2453d" class="pr-1 mr-2 negativeMargin"
            >not_interested</v-icon
          >
          Vencidos {{ allStatus["vencidos"] }}
        </v-chip>
      </v-flex>
      <v-flex no-wrap xs2 text-xs-left>
        <!-- <strong class="small">Vigentes</strong> -->
        <v-chip
          v-if="true"
          color="white"
          :class="['pl-0', statusSel.naoRecebidos ? 'naoRecebidos' : '']"
          @click="selChip('naoRecebidos')"
          label
          small
        >
        <v-icon color="#2938aa" class="pr-1 mr-2 negativeMargin">help</v-icon>
        Não recebidos {{ allStatus["nao_recebidos"] }}
        </v-chip>
      </v-flex>
      <v-flex no-wrap xs2 text-xs-left>
        <!-- <strong class="small">Vigentes</strong> -->
        <v-chip
          v-if="true"
          color="white"
          :class="['pl-0', statusSel.obtencao ? 'obtencao' : '']"
          @click="selChip('obtencao')"
          label
          small
        >
        <v-icon color="#696A6D" class="pr-1 mr-2 negativeMargin">search</v-icon>
        Em obtenção {{ allStatus["obtencao"] }}
        </v-chip>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="tableData"
      :class="[tableData.length ? '' : 'minHeight']"
    >
      <template v-slot:items="props">
        <tr
          @mouseover="props.item.hover = true"
          @mouseout="props.item.hover = false"
        >
          <td class="text-xs-center" v-if="inactivesShow">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon color="grey lighten-1" v-on="on">error</v-icon>
              </template>
              <span>Documento inativo</span>
            </v-tooltip>
          </td>
          <td v-if="!inactivesShow" class="text-xs-center">
            <template v-if="props.item.obtaining">
              <v-icon
                color="#696A6D"
                >search</v-icon
              >
            </template>
            <template v-else>
              <v-icon
                v-if="props.item.status == 1 || props.item.status == 4"
                color="#50ae55"
                >check_circle</v-icon
              >
              <v-icon v-if="props.item.status == 2" color="#f98c25"
                >warning</v-icon
              >
              <v-icon v-if="props.item.status == 3" color="#f2453d"
                >not_interested</v-icon
              >
              <v-icon v-if="props.item.status == 5" color="#2938aa">help</v-icon>
              <!-- <div
                style="border: 1px solid #ccc;"
                :class="['statusCircle', statusColors[props.item.status]]"
              ></div>-->
            </template>
          </td>
          <td class="text-xs-left">{{ props.item.name_fantasy }}</td>
          <td class="text-xs-left">{{ props.item.sub_type }}</td>
          <td class="text-xs-left">{{ props.item.type_name }}</td>
          <td class="text-xs-left posRelative">
            {{ getFormatedDate(props.item.validate_date) }}
            <div
              class="px-4 text-xs-center layout trControls"
              v-show="props.item.hover"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    v-if="docsPermissions.edit"
                    small
                    class="mr-2"
                    @click="editItem(props.item)"
                    >edit</v-icon
                  >
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    v-if="docsPermissions.view"
                    small
                    class="mr-2"
                    @click="editItem(props.item, 'viewForm')"
                    >remove_red_eye</v-icon
                  >
                </template>
                <span>Visualizar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    v-if="docsPermissions.remove && !props.item.active"
                    small
                    @click="confirmDelDocumentation(props.item)"
                    >check</v-icon
                  >
                </template>
                <span>Ativar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    v-if="docsPermissions.remove && props.item.active"
                    small
                    @click="confirmDelDocumentation(props.item)"
                    >block</v-icon
                  >
                </template>
                <span>Desativar</span>
              </v-tooltip>
            </div>
          </td>
          <td class="text-xs-left">
            <v-icon v-if="props.item.flag_not_send" color="#2938aa">help</v-icon>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DocumentationFormDlg from '@/components/syndication/documentations/DocumentationForm'
import SearchDocumentations from '@/components/syndication/documentations/SearchDocumentations'
import UploadFileDoc from '@/components/common/UploadFile'
import {
  documentation as documentationService,
  addDocument,
  updateDocument
} from '@/services/documentation'
import axios from 'axios'

const resetStatusSel = {
  selVig: false,
  aVencer: false,
  vencidos: false,
  naoRecebidos: false,
  obtencao: false
}

const resquestToSaveDocument = {
  patch: updateDocument,
  post: addDocument
}

export default {
  name: 'Documentation',

  components: {
    DocumentationFormDlg,
    SearchDocumentations,
    UploadFileDoc
  },

  data () {
    return {
      lastSearch: null,
      inactivesShow: false,
      statusSel: { ...resetStatusSel },
      allStatus: {
        a_vencer: 0,
        nao_recebidos: 0,
        vencidos: 0,
        vingente: 0,
        obtencao: 0
      },
      condominiumList: [],
      statusColors: {
        1: 'teal lighten-4',
        2: 'orange lighten-4',
        3: 'red lighten-4',
        4: 'blue-grey lighten-4',
        5: 'red lighten-4'
      },
      frmDocumentationDialog: false,
      uploadDialog: false,
      formData: null,
      headers: [
        { text: 'Status', sortable: true, value: 'status', align: 'center' },
        { text: 'Condomínio', sortable: true, value: 'name_fantasy' },
        { text: 'Documento', sortable: true, value: 'description' },
        { text: 'Tipo', sortable: true, value: 'type_name' },
        {
          text: 'Vencimento',
          value: 'validate_date',
          sortable: true,
          align: 'left'
        }
      // ,
      // { text: " ", value: "", sortable: false, align: "center" }
      ],
      tableDataSW: [],
      tableData: [],
      chipsTeste: false
    }
  },

  computed: {
    docsPermissions () {
      return this.$store.state.permissions.permissions.documentation
    },

    showDownloadButton () {
      try {
        return this.tableData.length > 0// && this.$store.state.permissions.permissions.Adm.adm
      } catch (error) {
        console.log('User is not an adm')
      }

      return false
    }
  },

  watch: {
    statusSel: {
      handler (val) {
        // console.log(val)
        let caseTrue = ''
        for (var prop in val) {
          // console.log(prop, val);
          if (val[prop]) {
            caseTrue = prop
          }
        }
        if (!caseTrue) {
          caseTrue = 'defaultCase'
        }
        // console.log(caseTrue);
        // selVig: false,
        // aVencer: false,
        // vencidos: false,
        // naoRecebidos: false
        let arr
        switch (caseTrue) {
          case 'selVig':
            arr = [...this.tableDataSW].filter(
              (doc) => doc.obtaining === false && (doc.status === 1 || doc.status === 4)
            )
            this.tableData = [...arr]
            break
          case 'aVencer':
            arr = [...this.tableDataSW].filter((doc) => doc.status === 2 && doc.obtaining === false)
            this.tableData = [...arr]
            break
          case 'vencidos':
            arr = [...this.tableDataSW].filter((doc) => doc.status === 3 && doc.obtaining === false)
            this.tableData = [...arr]
            break
          case 'naoRecebidos':
            arr = [...this.tableDataSW].filter((doc) => doc.flag_not_send && doc.obtaining === false)
            this.tableData = [...arr]
            break
          case 'obtencao':
            arr = [...this.tableDataSW].filter((doc) => doc.obtaining)
            this.tableData = [...arr]
            break
          case 'defaultCase':
            this.tableData = [...this.tableDataSW]
            break
        }
      },
      deep: true
    }
  },

  methods: {
    downloadExcel () {
      let obj = {
        url: '/api/document/sheet',
        query: this.lastSearch,
        method: 'post',
        filename: "Documentos.xlsx"
      }

      this.$store.dispatch('request/download', obj).then(response => {
        console.log('DOWNLOAD SUCCESS')
      })
    },

    getFormatedDate (date) {
      if (date) {
        // props.item.validate_date | moment("DD/MM/YYYY")
        if (date === 'Em obtenção' || date === 'Indeterminado') {
          return date
        }

        return this.$moment(date).format('DD/MM/YYYY')
      }

      return ''
    },

    resetList () {
      this.tableData = [...this.tableDataSW]
      this.statusSel = { ...resetStatusSel }
    },

    selChip (sel) {
      console.log('sel: ', sel)
      if (this.statusSel[sel]) {
        this.statusSel[sel] = !this.statusSel[sel]
        return
      }

      this.statusSel = { ...resetStatusSel }
      this.statusSel[sel] = !this.statusSel[sel]
    },

    confirmDelDocumentation (data) {
      // console.log(data)
      let action = data.active
      let obj = {
        message: `Você deseja ${
          !action ? 'ativar' : 'desativar'
        } o documento "${data.sub_type}"?`,
        title: `${!action ? 'Ativar' : 'Desativar'} documento`,
        callback: (_) => {
          this.delDocumentation(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delDocumentation (data) {
      let obj = {
        // url: "/api/document/" + data.id,
        url: '/api/document/disable_doc/' + data.id,
        query: '',
        // method: "delete"
        method: 'post'
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Documento removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getDocumentation(this.lastSearch)
      })
    },

    openDialogForm (type) {
      // console.log(this.$store.state.permissions.condominiums);
      if (type === 'upLoad') {
        this.uploadDialog = true
        return
      }
      this.formData = null
      this.frmDocumentationDialog = true
    },

    closeDialogForm (type) {
      if (type === 'upLoad') {
        this.uploadDialog = false
        return
      }
      this.frmDocumentationDialog = false
    },

    async getDocumentation (documentation) {
      this.$store.commit('showLoader', {
        circle: true
      })

      if (!documentation) {
        documentation = {}
      }

      if (
        documentation.flag_active === null ||
        documentation.flag_active === undefined ||
        documentation.flag_active === ''
      ) {
        documentation.flag_active = false
      }

      this.lastSearch = documentation

      let dataSearch = {}

      if (
        documentation &&
        (documentation.condominium_id || documentation.name)
      ) {
        dataSearch.params = {
          ...documentation
        }
      }

      this.inactivesShow = documentation.flag_active

      const response = await documentationService({ ...documentation })

      this.statusSel = { ...resetStatusSel }
      this.tableDataSW = [...response.documentation]
      this.tableData = [...response.documentation]
      this.allStatus = response.status

      this.$store.commit('hideLoader')
    },

    editItem (item, view) {
      view === 'viewForm' ? (item.view = true) : (item.view = false)

      this.formData = Object.assign({}, item)
      this.frmDocumentationDialog = true
    },

    sendFile (data) {
      // api/document/uploadfiles
      this.$store.commit('showLoader', {
        circle: true
      })

      let USER_TOKEN = localStorage.getItem('token')
      let AuthStr = 'Bearer '.concat(USER_TOKEN)
      let formData = new FormData()

      for (var key in data) {
        formData.append(key, data[key])
      }
      // console.log(formData);
      // return;
      axios.defaults.baseURL =
        process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL
          : process.env.VUE_APP_API_URL_DEV
      axios
        .post('/api/document/uploadfiles', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: AuthStr
          }
        })
        .then((resp) => {
          this.$store.commit('hideLoader')
          let obj = {
            message: 'Upload realizado com sucesso!',
            title: 'Sucesso',
            callback: (_) => {
              this.uploadDialog = false
              this.getDocumentation(this.lastSearch)
            },
            type: 'success',
            btConfirm: { name: 'Fechar', show: true },
            btCancel: { name: 'Fechar', show: false }
          }
          this.$store.commit('confirmMessage/showConfirmMessage', obj)
        })
        .catch((error) => {
          let paramModal = {}
          paramModal.message = error.response
            ? error.response.data.errors
              ? Object.values(error.response.data.errors).join('<br>')
              : error.response.data.message
            : 'Contate o administrador do sistema'
          paramModal.title = 'Ocorreu erro'
          paramModal.type = 'error'
          paramModal.callback = null
          paramModal.btConfirm = {
            name: 'Ok',
            show: true
          }
          paramModal.btCancel = {
            show: false
          }
          this.$store.commit('hideLoader')
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal)
        })
    },

    async saveDocumentation (document) {
      this.$store.commit('showLoader', {
        circle: true
      })

      const requestMethod = document.id ? 'patch' : 'post'

      const response = await resquestToSaveDocument[requestMethod](document)

      if (response) {
        let opts = {
          message: `Documento ${document.id ? 'alterado' : 'adicionado'} com sucesso`,
          type: 'success'
        }

        this.$store.commit('showAlert', opts)

        this.closeDialogForm()
      }

      this.$store.commit('hideLoader')

      this.getDocumentation(this.lastSearch)
    }
  }
}
</script>

<style>
.negativeMargin {
  margin-left: -5px !important;
}
.infoDocs .v-chip .v-chip__content {
  cursor: pointer;
  background: white !important;
}

.infoDocs .v-chip.vigente .v-chip__content {
  border-top: 3px solid #50ae55;
}
.infoDocs .v-chip.aVencer .v-chip__content {
  border-top: 3px solid #f98c25;
}
.infoDocs .v-chip.vencidos .v-chip__content {
  border-top: 3px solid #f2453d;
}
.infoDocs .v-chip.naoRecebidos .v-chip__content {
  border-top: 3px solid #2938aa;
}
.infoDocs .v-chip.obtencao .v-chip__content {
  border-top: 3px solid #696A6D;
}

.infoDocs .v-chip--small {
  height: 32px !important;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}
.statusCircle {
  height: 15px;
  border-radius: 50px;
  width: 15px;
}
div.statusCircle.lighten-4 {
  border: solid #bbb 1px !important;
}
.minHeight table {
  min-height: 250px;
}
.miniPrimary {
  font-size: 16px !important;
}
</style>
